import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { BACKDROP_TYPES } from './constants';
import { showBackdrop, hideBackdrop } from './actions';

// type, reason should stay stable
export const useBackdrop = ({ type = BACKDROP_TYPES.PRELOADER, reason, isShown }) => {
  const dispatch = useDispatch();
  const shownBackdropRef = useRef(null);

  useEffect(() => {
    if (isShown) {
      shownBackdropRef.current = {
        type, reason: reason ?? `${Math.random()}`,
      };
      dispatch(showBackdrop(shownBackdropRef.current));
    } else if (shownBackdropRef.current) {
      dispatch(hideBackdrop(shownBackdropRef.current));
      shownBackdropRef.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShown, dispatch]);

  useEffect(() => () => {
    if (shownBackdropRef.current) {
      dispatch(hideBackdrop(shownBackdropRef.current));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
